import { Avatar } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledAvatar = styled(Avatar)`
  width: 16px;
  height: 16px;
  margin-left: 4px;
`

export function SenderIcon({ Icon }: { Icon: string }) {
  return Icon ? <StyledAvatar src={Icon} /> : null
}
